"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../cdn.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HeaderWrapper = _ref => {
  let {
    heading = false,
    element
  } = _ref;
  if (heading) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "fs-h4"
    }, element === null || element === void 0 ? void 0 : element.title);
  }
  return /*#__PURE__*/_react.default.createElement("span", null, element === null || element === void 0 ? void 0 : element.title);
};
const HeaderLink = _ref2 => {
  var _element$classList, _element$classList2, _element$classList3;
  let {
    element
  } = _ref2;
  const isHeading = (element === null || element === void 0 || (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.includes("heading")) || (element === null || element === void 0 || (_element$classList2 = element.classList) === null || _element$classList2 === void 0 ? void 0 : _element$classList2.includes("heading-link"));
  if (element !== null && element !== void 0 && element.url && element.url.length > 0 && (element === null || element === void 0 ? void 0 : element.url) !== "#" && element !== null && element !== void 0 && (_element$classList3 = element.classList) !== null && _element$classList3 !== void 0 && _element$classList3.includes("external-link")) {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: element.url,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
      element: element,
      heading: isHeading
    }), /*#__PURE__*/_react.default.createElement("i", {
      className: "fa-regular fa-arrow-up-right-from-square"
    }), isHeading && /*#__PURE__*/_react.default.createElement("hr", null));
  }
  if (element !== null && element !== void 0 && element.url && element.url.length > 0 && element.url !== "#") {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: element.url
    }, /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
      element: element,
      heading: isHeading
    }), isHeading && /*#__PURE__*/_react.default.createElement("hr", null));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
    element: element,
    heading: isHeading
  }), isHeading && /*#__PURE__*/_react.default.createElement("hr", null));
};
const Header = exports.Header = /*#__PURE__*/_react.default.forwardRef((_ref3, ref) => {
  let {
    logo,
    logoSmall = "",
    logoAlt = "Forbrukerrådet logo",
    homeLink = "./",
    showSearch = true,
    searchTerm = "Søk",
    searchActive = false,
    showExpandableMenu = true,
    expandableMenuTerm = "Meny",
    expandableMenuColumns = [],
    children,
    className = ""
  } = _ref3;
  const [megaMenuActive, setMegaMenuActive] = (0, _react.useState)(false);
  const [megaMenuBtnActive, setMegaMenuBtnActive] = (0, _react.useState)(false);
  const [megaMenuIconActive, setMegaMenuIconActive] = (0, _react.useState)(false);
  const [overlayActive, setOverlayActive] = (0, _react.useState)(false);
  const [headerActive, setHeaderActive] = (0, _react.useState)(false);
  const [openMenu, setOpenMenu] = (0, _react.useState)(false);
  const [delayedOpen, setDelayedOpen] = (0, _react.useState)(false);
  const openMenuRef = (0, _react.useRef)(openMenu);
  const megaMenuRef = (0, _react.useRef)(null);
  const megaMenuBtnRef = (0, _react.useRef)(null);
  const columns = expandableMenuColumns.length > 4 ? 3 : 12 / expandableMenuColumns.length;
  (0, _react.useEffect)(() => {
    openMenuRef.current = openMenu;
    let timeout;
    if (openMenu) {
      setDelayedOpen(true);
      timeout = setTimeout(() => {
        setMegaMenuActive(true);
        setMegaMenuBtnActive(true);
        setMegaMenuIconActive(true);
        setOverlayActive(true);
        setHeaderActive(true);
        document.body.classList.add("no-scroll");
      }, 1);
    } else {
      setMegaMenuActive(false);
      setMegaMenuBtnActive(false);
      setMegaMenuIconActive(false);
      setHeaderActive(false);
      setOverlayActive(false);
      document.body.classList.remove("no-scroll");
      timeout = setTimeout(() => {
        setDelayedOpen(false);
      }, 400);
    }

    // Cleanup
    return () => clearTimeout(timeout);
  }, [openMenu]);
  (0, _react.useEffect)(() => {
    if (showExpandableMenu === false) {
      return;
    }
    const handleEscapeClick = e => {
      if (openMenuRef.current) {
        if (e.key === "Escape") {
          setOpenMenu(false);
        }
        if (megaMenuRef.current && !megaMenuRef.current.contains(e.target) && e.key === "Tab") {
          setOpenMenu(false);
        }
      }
    };
    document.addEventListener("keyup", handleEscapeClick);

    // Cleanup
    return () => document.removeEventListener("keyup", handleEscapeClick);

    //eslint-disable-next-line
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: "#main-content",
    className: "skip-link"
  }, "Hopp til hovedinnhold"), /*#__PURE__*/_react.default.createElement("header", {
    id: "header",
    className: ["header", openMenu && headerActive === true && "mega-menu-is-active", ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container flex"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: homeLink,
    className: "header-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: logoAlt
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: homeLink,
    className: "header-logo-alt"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logoSmall || logo,
    alt: logoAlt
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: "header-nav"
  }, children && /*#__PURE__*/_react.default.createElement("ul", null, Array.isArray(children) ? children.map((child, i) => /*#__PURE__*/_react.default.createElement("li", {
    key: i
  }, child)) : /*#__PURE__*/_react.default.createElement("li", null, children))), showSearch && /*#__PURE__*/_react.default.createElement("a", {
    href: "/search",
    className: ["header-search-btn", "btn", "button-default", searchActive && "is-active"].filter(v => !!v).join(" ") || undefined
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-regular fa-magnifying-glass text-default"
  }), /*#__PURE__*/_react.default.createElement("span", null, searchTerm)), showExpandableMenu && /*#__PURE__*/_react.default.createElement("button", {
    className: ["header-menu-btn", "btn", megaMenuBtnActive === true && "is-active"].filter(v => !!v).join(" ") || undefined,
    onClick: () => setOpenMenu(v => !v),
    ref: megaMenuBtnRef
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: ["fbr-icon-bars", megaMenuIconActive === true && "is-active"].filter(v => !!v).join(" ") || undefined
  }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("span", null, expandableMenuTerm))), showExpandableMenu && /*#__PURE__*/_react.default.createElement("div", {
    id: "mega-menu",
    className: ["mega-menu", "pt-10", "pb-11", "bg-white", delayedOpen === true && "block", megaMenuActive === true && "is-active"].filter(v => !!v).join(" ") || undefined,
    ref: megaMenuRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container grid"
  }, expandableMenuColumns.map((column, idx) => /*#__PURE__*/_react.default.createElement("nav", {
    key: idx,
    className: "col-".concat(columns, " col-md-6 col-sm-12")
  }, /*#__PURE__*/_react.default.createElement("ul", null, column.map((item, i) => /*#__PURE__*/_react.default.createElement("li", {
    key: i,
    className: item.classList || undefined
  }, /*#__PURE__*/_react.default.createElement(HeaderLink, {
    element: item
  }))))))))), (showSearch || showExpandableMenu) && /*#__PURE__*/_react.default.createElement("div", {
    id: "overlay",
    className: [delayedOpen === true && "block", overlayActive === true && "is-active"].filter(v => !!v).join(" ") || undefined
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: "main-content"
  }));
});